import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import {
  Box,
  Checkbox,
  Dialog,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  ModeEdit,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import CreateWO from "./WO";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import StatusCheckboxFilter from "../../../Component/StatusCheckboxFilter"
import { encode } from "../../../Component/JWT/Formatt";
import { fromUTC } from "../../../utils/dateUtil";
// import AssetModal from "./AssetModal";
// import CreateAssetCategory from "./AssetCategoryModal";

const WorkOrder = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const [woScheduleType,setWOScheduleType]=useState("WO")
  const backArrow = searchParams.get("backArrow");
      const [defaultWorkTypeId, setdefaultWorkTypeId] = useState("");
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [insLength, setLength]=useState([]);
  const [workTypesList, setWorkTypesList] = useState([]);

  useEffect(() => {
    getData();
    getWorkTypes();
    dispatch({ type: "woEditData", payload: { edit: false, data: {} } });
    dispatch({type:"workType", payload: { edit: false, data:{}}})
  }, []);

  const getWorkTypes = async () => {
    try {
      const wotypeLink = masterAPI["selectList"].workordertype;
      const res = await axiosPrivate.get(`${wotypeLink}`);
      setWorkTypesList(res.data);
    } catch (e) {
      console.log(e, "work types list fetch error");
      setWorkTypesList([]);
    }
  };

  const getData = async() => {
    setIsLoading(true);
    const link = masterAPI["workOrder"].link;
   await axiosPrivate
      .get(`${link}`)
      .then((res) => {
         const updatedResult = res.data.result
        //                                      .map(woResult => ({ ...woResult, permitCode: "PTW00148" }));

        //    console.log(updatedResult);
        // updatedResult.sort((a, b) => {
        //   return b.code.localeCompare(a.code, undefined, {
        //     numeric: true,
        //     sensitivity: 'base'
        //   });
        // });
        if (backArrow === "true") {
          setWOScheduleType("INS"); 
          getInspData()
        }
        if (filterValue === "enableData") {
          const filterDataResult = updatedResult.filter(
            (fil) => fil.isActive
          );
          console.log(filterDataResult, "filterData");
          setData(filterDataResult);
          setBackUpData(updatedResult);
        } else {
          setData(updatedResult);
          setBackUpData(updatedResult);
        }
        insWoLength();
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "workorder");
        setIsLoading(false);
        setData([])
        setBackUpData([])
      });
       const wotypeLink = masterAPI["selectList"].workordertype;
          await axiosPrivate
            .get(`${wotypeLink}`)
            .then((res) => {
              const defaultWorkTypeIdtest = res.data.find(
                (item) => item.text === "CM"
              )?.value;
              setdefaultWorkTypeId(defaultWorkTypeIdtest);
              console.log("test", defaultWorkTypeId);
            })
            .catch((e) => {
              console.log(e, "work type Create Wo");
            });
  };

  const getInspData=async()=>{
    setIsLoading(true);
    const link = masterAPI["inspWo"].link;
   await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        res.data.result.sort((a, b) => {
          return b.code.localeCompare(a.code, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive
          );
          console.log(filterDataResult, "filterData");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "insp");
        setIsLoading(false);
        setData([])
        setBackUpData([])
      });
  }

  const insWoLength = async() => {
    const lengthlink = masterAPI["inspWo"].link;
    await axiosPrivate.get(`${lengthlink}`)
    .then(res=>{
      setLength(res.data.result.length)
    }).catch(e=>{
       setLength(0)
      console.log(e, "lengtherror");
    })
  }
  console.log('length',insLength)

  const handleButtonNew = () => {
    // setMode("Create");
    // setCreate(true);
    dispatch({type: "workType", payload:{edit: true, data: defaultWorkTypeId}});
    navigate("/workordercreate");
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    dispatch({ type: "woEditData", payload: { edit: true, data: data } });
    navigate("/workordercreate");
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["workOrder"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete assets");
  //     });
  // };

  const handleDelete = async(e, id) => {
    const enableLink = woScheduleType==="WO"? masterAPI["workOrder"].enable : masterAPI["inspWo"].enable;
    const disableLink = woScheduleType==="WO"? masterAPI["workOrder"].disable : masterAPI["inspWo"].disable;
    if (e.target.checked) {
     await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          if(woScheduleType==="WO"){
            getData();
          }else{
            getInspData()
          }
         
        })
        .catch((e) => {
          console.log(e, "enable wo");
        });
    } else {
     await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          if(woScheduleType==="WO"){
            getData();
          }else{
            getInspData()
          }
        })
        .catch((e) => {
          console.log(e, "disable wo");
        });
    }
  };
const columns = [
  {
    accessor: "duration",
    disableFilters: true,
    Cell: () => (
      <Box sx={{ width: color.checkBoxWidth }}>
        <Checkbox />
      </Box>
    ),
  },
  {
    Header: "WO Code",
    accessor: "code",
    Cell: ({ cell }) => {
      const { id, priorityColour } = cell.row.original;
      return (
        <Link
          to={`/workorderview?id=${encode(id)}`}
          style={{
            color: priorityColour || "#0d6efd",
            textDecorationLine: "underline",
            fontWeight: 800,
          }}
        >
          {cell.value}
        </Link>
      );
    },
  },
  {
    Header: "WO Name",
    accessor: "workOrderName",
    Cell: ({ cell }) => {
      const { priorityColour } = cell.row.original;
      return (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: priorityColour || "inherit",
          }}
        >
          {cell.value}
        </Typography>
      );
    },
  },
  {
    Header: "Asset",
    accessor: "assetName",
    Cell: ({ cell }) => {
      const { priorityColour } = cell.row.original;
      return (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: priorityColour || "inherit",
          }}
        >
          {cell.value}
        </Typography>
      );
    },
  },
  {
    Header: "Work Type",
    accessor: "workTypeName",
    Cell: ({ cell }) => {
      const { priorityColour } = cell.row.original;
      // const workType = workTypesList.find((item) => item.value === cell.value);
      // const workTypeName = workType ? workType.text : "---";

      return (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: priorityColour || "inherit",
          }}
        >
          {cell.value}
        </Typography>
      );
    },
  },
  {
    Header: "Planned Start Date",
    accessor: "plannedStartDate",
    Cell: ({ cell }) => {
      const { priorityColour } = cell.row.original;
      return (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: priorityColour || "inherit",
          }}
        >
          {cell.value!==undefined&& cell.value!==null ? fromUTC(cell.value).dayjsObject.format("DD/MM/YYYY") : "" }
        </Typography>
      );
    },
  },
  {
    Header: "Planned End Date",
    accessor: "plannedEndDate",
    Cell: ({ cell }) => {
      const { priorityColour } = cell.row.original;
      return (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: priorityColour || "inherit",
          }}
        >
          {cell.value!==undefined&& cell.value!==null ? fromUTC(cell.value).dayjsObject.format("DD/MM/YYYY") : "" }
        </Typography>
      );
    },
  },
  {
    Header: "Status",
    accessor: "status",
    Filter: StatusCheckboxFilter,
    filter: "includesSome",
    disableFilters: false,
    Cell: ({ cell }) => {
      const { priorityColour } = cell.row.original;
      return (
        <Typography
          sx={{
            fontSize: "inherit",
            fontWeight: "inherit",
            color: priorityColour || "inherit",
          }}
        >
          {cell.value}
        </Typography>
      );
    },
  },
  {
    Header: "Actions",
    Cell: ({ cell }) => {
      const row = cell.row.original;
      return (
        <Box sx={{ whiteSpace: "nowrap" }}>
          <IconButton
            disabled={!actionsAllow.edit || row.status.toUpperCase() === "INPRG" || row.status?.toUpperCase() === 'PAPPR'||row.status?.toUpperCase() === 'PENAPP'}
          >
            <EditOutlined
              onClick={() => handleEdit(row)}
              sx={{
                fontSize: color.masterEditDelButton,
                color:
                  actionsAllow.edit && row.status !== "INPRG"&& row.status?.toUpperCase() !== 'PAPPR'&&row.status?.toUpperCase() !== 'PENAPP'
                    ? color.masterEditDelButtonColor
                    : "default",
              }}
            />
          </IconButton>

          <Switch
            disabled={!actionsAllow.delete || row.status !== "NEW"}
            checked={row.isActive}
            onChange={(e) => handleDelete(e, row.id)}
          />
        </Box>
      );
    },
  },
];

//   const columns = [
//     {
//       accessor: "duration",
//       disableFilters: true,
//       Cell: () => {
//         return (
//           <Box sx={{ width: color.checkBoxWidth }}>
//             <Checkbox
//               // icon={<RadioButtonUncheckedOutlined />}
//               // checkedIcon={<CheckCircle />}
//             />
//           </Box>
//         );
//       },
//     },
//    {
//   Header: "WO Code",
//   accessor: "code",
//   Cell: ({ cell }) => {
//     const { id, priorityColour } = cell.row.original;
//     return (
//       <Link
//         to={`/workorderview?id=${encode(id)}`}
//         style={{
//           color: priorityColour || "#0d6efd", // fallback if null/empty
//           textDecorationLine: "underline",
//           fontWeight: 800,
//         }}
//       >
//         {cell.value}
//       </Link>
//     );
//   },
// },
//     {
//       Header: "WO Name",
//       accessor: "workOrderName",
//     },
//     {
//       Header: "Asset",
//       accessor: "assetName",
//     },
//     // {
//     //   Header: "Job No",
//     //   accessor: "notes",
//     // },
//     {
//       Header: "Sevice Request Code",
//       accessor: "serviceRequestCode",
//     },
//     {
//       Header: "PM",
//       accessor: "pmCode",
//     },
//     // {
//     //   Header: "Permit Code",
//     //   accessor: "permitCode",
//     // },
   
//     {
//       Header: "Planned Start Date",
//       accessor: "plannedStartDate",
//       Cell: ({ cell }) => {
//         return (
//           <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
//             {cell.value !== null && cell.value !== undefined
//               ? moment(cell.value).format("DD/MM/YYYY")
//               : "---"}
//           </Typography>
//         );
//       },
//     },
//     {
//       Header: "Planned End Date",
//       accessor: "plannedEndDate",
//       Cell: ({ cell }) => {
//         return (
//           <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
//             {cell.value !== null && cell.value !== undefined
//               ? moment(cell.value).format("DD/MM/YYYY")
//               : "---"}
//           </Typography>
//         );
//       },
//     },
//     {
//       Header: "Status",
//       accessor: "status",
//       // Disable the default filter and use our custom one
//       Filter: StatusCheckboxFilter,
//       filter: 'includesSome',
//       // Add this to make the filter UI appear as checkboxes
//       disableFilters: false, // Ensure filtering is enabled
//       // Your existing Cell renderer
//       Cell: ({ cell }) => (
//         <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
//           {cell.value}
//         </Typography>
//       ),
//     },
//     {
//       Header: "Actions",
//       Cell: ({ cell }) => {
//         // console.log(cell)
//         return (
//           <Box sx={{ whiteSpace: "nowrap" }}>
//             <IconButton
//               disabled={
//                 !actionsAllow.edit || cell.row.original.status === "INPRG"
//               }
//             >
//               <EditOutlined
//                 onClick={() => {
//                   handleEdit(cell.row.original);
//                 }}
//                 sx={{
//                   fontSize: color.masterEditDelButton,
//                   color:
//                     actionsAllow.edit && !cell.row.original.status === "INPRG"
//                       ? color.masterEditDelButtonColor
//                       : "default",
//                 }}
//               />
//             </IconButton>
//             {/* <IconButton disabled={!actionsAllow.delete|| cell.row.original.status!=="NEW"}>
//               <DeleteOutline
//                 onClick={() => {
//                   handleDelete(cell.row.original.id);
//                 }}
//                 sx={{
//                   fontSize: color.masterEditDelButton,
//                   color: actionsAllow.delete&&cell.row.original.status==="NEW"? color.masterEditDelButtonColor:"default",
//                 }}
//               />
//             </IconButton> */}
//             <Switch
//               disabled={
//                 !actionsAllow.delete || cell.row.original.status !== "NEW"
//               }
//               checked={cell.row.original.isActive}
//               onChange={(e) => {
//                 handleDelete(e, cell.row.original.id);
//               }}
//             />
//           </Box>
//         );
//       },
//     },
//   ];
  const inspColumns = [
    {
      accessor: "duration",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
              // icon={<RadioButtonUncheckedOutlined />}
              // checkedIcon={<CheckCircle />}
            />
          </Box>
        );
      },
    },
    {  
      Header: "Inspection WO Code",
      accessor: "code",
      // disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Link
          //   to={`/inspwoview?id=${cell.row.original.id}`}
            to={`/inspwoview?id=${encode(cell.row.original.id)}`}
            style={{
              color: "#0d6efd",
              textDecorationLine: "underline",
              fontWeight: 800,
            }}
          >
            {cell.value}
          </Link>
        );
      },
    },
    {
      Header: "Inspection Name",
      accessor: "inspectionName",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Planned Start Date",
      accessor: "plannedStartDate",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
            {cell.value !== null && cell.value !== undefined
              ? moment(cell.value).format("DD/MM/YYYY")
              : "---"}
          </Typography>
        );
      },
    },
    {
      Header: "Planned End Date",
      accessor: "plannedEndDate",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
            {cell.value !== null && cell.value !== undefined
              ? moment(cell.value).format("DD/MM/YYYY")
              : "---"}
          </Typography>
        );
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            {/* <IconButton
              disabled={
                !actionsAllow.edit 
              }
            >
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    actionsAllow.edit 
                      ? color.masterEditDelButtonColor
                      : "default",
                }}
              />
            </IconButton> */}
            {/* <IconButton disabled={!actionsAllow.delete|| cell.row.original.status!=="NEW"}>
              <DeleteOutline
                onClick={() => {
                  handleDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.delete&&cell.row.original.status==="NEW"? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton> */}
            <Switch
              disabled={
                !actionsAllow.delete 
              }
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  const woScheduleTypeChange=(type)=>{
    setWOScheduleType(type)
   if(type==="WO"){
    getData()
   }else{
    getInspData()
   }
      
  }
  
  const calendarHandle=()=>{
    dispatch({type:"drawerOpen",payload:{bol:true,open:false}})
    navigate("/workordercalendarview")
   
    dispatch({type:"workOrderData",payload:data})
  }

  const tableFilterTypes = {
    includesSome: (rows, id, filterValues) => {
      if (!filterValues || filterValues.length === 0) return rows;
      return rows.filter(row => {
        const rowValue = row.values[id];
        return filterValues.includes(rowValue);
      });
    },
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {(woScheduleType!=="WO"?"Inspection ":"")+masterAPI["workOrder"].title}
        </Typography>
      </Box>

      <TableContainer
        columns={woScheduleType==="WO"?columns:inspColumns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
        iconBadge={true}
        iconWOCount={0}
        iconInspCount={insLength}
        woScheduleTypeChange={woScheduleTypeChange}
        calendarHandle={calendarHandle}
        filterTypes={tableFilterTypes}
      />
      <Dialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <CreateWO
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default WorkOrder;
